import React from "react";

const CreateGroup = React.lazy(() => import("./CreateGroup"));
const Index = React.lazy(() => import("./index"));
const GroupDetails = React.lazy(() => import("./GroupDetails"));

export const groupRoutes = [
	{
		path: "/admin/ledgerGroup",
		name: "Group",
		element: <Index />,
	},
	{
		path: "/admin/ledgerGroup/create",
		name: "Create or Update Group",
		element: <CreateGroup />,
	},
	{
		path: "/admin/ledgerGroup/update/:id?",
		name: "Create or Update Group",
		element: <CreateGroup />,
	},
	{
		path: "/admin/ledgerGroup/:id",
		name: "Group",
		element: <GroupDetails />,
	}
];
